// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Core__Option = require("@rescript/core/src/Core__Option.bs.js");

function optIncludes(src, v) {
  return Core__Option.getOr(src, []).includes(v);
}

function toggleIncluded(src, v) {
  var arr = Core__Option.getOr(src, []).slice();
  if (arr.includes(v)) {
    var newArr = arr.filter(function (c) {
          return c !== v;
        });
    if (newArr.length > 0) {
      return newArr;
    } else {
      return ;
    }
  }
  arr.push(v);
  return arr;
}

exports.optIncludes = optIncludes;
exports.toggleIncluded = toggleIncluded;
/* No side effect */
